import { useSeo } from "@/hooks/useSeo";
import { Hero } from "@/components/home/Hero";
import { CoursesSection } from "@/components/home/CoursesSection";
import { ProcessSection } from "@/components/home/ProcessSection";
import { ProjectsSection } from "@/components/home/ProjectsSection";
import { WhySection } from "@/components/home/WhySection";
import { EnquirySection } from "@/components/home/EnquirySection";

export default function Home() {
  useSeo(null, "MUCCI Academy offers inquiry-based learning for Years 5–10 across New Zealand: Science Inquiry, Social Studies, Engineering and Critical Thinking, all taught through project-based learning. Explore. Question. Create the Future.");
  return (
    <div data-testid="home-page">
      <Hero />
      <CoursesSection />
      <ProcessSection />
      <ProjectsSection />
      <WhySection />
      <EnquirySection />
    </div>
  );
}
